import React from "react";
import Slider from "react-slick";
import { BtnArrow } from "../../_atoms/_btn-arrow/BtnArrow";
import { BtnSimple } from "../../_atoms/_btn-simple/BtnSimple";
import { FormSelectSimple } from "../../_atoms/_form-input-simple/FormSelectSimple";
import { Form } from "../../_molecules/_form/Form";
import "./_car-carousel.scss";
import { sendAnalytics } from "../../../utils/analytics"; 

export const CarCarousel = ({ data, onChange, onSubmit, showSelector, show24 }) => {
  let slides;

  if (!!data) {
    const models = Object.values(data);
    slides = models.map((model) => {
      const codes = model.codes;
      return (
        <div key="model" className="car-carousel__slide">
          <span className="h3">{model.model_range}</span>
          <img src={`https://api.bmw.es/cosy/?image=${model.model_range}.jpg`} alt="" />
          <Form
            css="form--simple"
            onSubmit={(event) => {
              event.preventDefault(); 

              const selectedVinElement = event.target.elements["vin"];
              const selectedAgeElement = event.target.elements["age"];

              const selectedOption = selectedVinElement.options[selectedVinElement.selectedIndex];
              const modelRange = selectedOption.getAttribute("data-model-range");
              const fuelType = selectedOption.getAttribute("data-fuel");
              const group = selectedOption.getAttribute("data-group");
              const serie = selectedOption.getAttribute("data-serie");

              const analyticsInfo = {
                modelRange,
                fuelType,
                group,
                serie,
                selectedVin: selectedVinElement.value,
                selectedAge: selectedAgeElement.value,
              };

              // Send analytics when the user clicks "Calcular precio"
              sendAnalytics("Click en modelo elegido", JSON.stringify(analyticsInfo));

              onSubmit(event);
            }}>
            <FormSelectSimple label="Elige motor" name="vin" onChange={onChange}>
              {codes.map((item) => {
                return (
                  <option
                    key={item.name}
                    data-model-range={model.model_range}
                    data-fuel={item.fuel}
                    data-group={item.group_id}
                    data-serie={model.serie}
                    value={item.VIN}
                    date={item.date_SOP}>
                    {item.name}
                  </option>
                );
              })}
            </FormSelectSimple>

            <FormSelectSimple label="Elige antiguedad" name="age" onChange={onChange}>
              {show24 && <option value="VO">Más de 24 meses</option>}
              <option value="VN">Menos de 24 meses</option>
            </FormSelectSimple>

            <BtnSimple type="submit" children="Calcular precio" aria="Calcular precio" css="btn-simple--1" />
          </Form>
        </div>
      );
    });
  }

  const carouselSettings = {
    dots: false,
    infinite: slides.length > 3,
    speed: 500,
    slidesToShow: slides.length > 3 ? 3 : 1.9,
    slidesToScroll: 1,
    centerMode: true,
    lazyLoad: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1.9,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },

      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
    ],

    prevArrow: (
      <div className="car-carousel__btn-prev">
        <BtnArrow type="button" aria="Ver modelos siguientes" css="btn-simple btn-simple--1" />
      </div>
    ),

    nextArrow: (
      <div className="car-carousel__btn-next">
        <BtnArrow type="button" aria="Ver modelos anteriores" css="btn-simple btn-simple--1 btn-arrow--right" />
      </div>
    ),
  };

  return (
    <div className="car-carousel">
      <Slider {...carouselSettings}>{slides}</Slider>
    </div>
  );
};

// <div>
//             <h3>1</h3>
//           </div>
//           <div>
//             <h3>2</h3>
//           </div>
//           <div>
//             <h3>3</h3>
//           </div>
//           <div>
//             <h3>4</h3>
//           </div>
//           <div>
//             <h3>5</h3>
//           </div>
//           <div>
//             <h3>6</h3>
//           </div>
